import React from 'react';
import IntegrationDocTemplate from '../../../../components/IntegrationDocTemplate';

export default function DocsWalmart() {
  return (
    <IntegrationDocTemplate
      title="Walmart Marketplace"
      category="Marketplace"
      status="live"
      summary="Walmart Marketplace API — orders, items, inventory, pricing, fulfillment. OAuth 2.0 client credentials with 15-min access tokens. Per-seller rate limits. Walmart Fulfillment Services (WFS) supported. Separate EDI path available for suppliers."
      prerequisites={[
        'Walmart Marketplace seller account (must be US-based business).',
        'Client ID + Client Secret from developer.walmart.com.',
        'Seller compliance metrics in good standing.',
      ]}
      connectSteps={[
        <>Text us "Walmart" with your phone number.</>,
        'Paste your Client ID + Client Secret in the connection wizard.',
        'First sync pulls items + last 30 days of orders + inventory.',
        'Optional: set up Walmart Fulfillment Services (WFS) for the items you want Walmart to fulfill.',
      ]}
      syncedData={[
        { type: 'Orders', detail: 'list_orders with status filter; full line items; acknowledge within 24h' },
        { type: 'Items', detail: 'list_items + upload_item_feed (MP_ITEM); Item Spec 5.0 support' },
        { type: 'Inventory', detail: 'get/update_inventory with fulfillment lag time' },
        { type: 'Pricing', detail: 'update_price with currency + amount' },
        { type: 'Fulfillment', detail: 'ship_order_lines and cancel_order_lines' },
      ]}
      agents={[
        { id: 'walmart_listing_agent', name: 'walmart_listing_agent', role: 'Item Spec 5.0 compliance' },
        { id: 'head_ecommerce', name: 'head_ecommerce', role: 'Channel routing director' },
        { id: 'cross_channel_inventory_agent', name: 'cross_channel_inventory_agent', role: 'Reserves inventory across Walmart + other channels' },
      ]}
      troubleshooting={[
        { question: '401 Unauthorized', answer: 'Walmart tokens expire every 15 min — our client refreshes automatically. If you see persistent 401s, regenerate Client Secret in developer.walmart.com.' },
        { question: 'Item upload fails with "spec_violation"', answer: 'Walmart enforces Item Spec 5.0 strictly. Check the sync_log for the specific attribute. walmart_listing_agent suggests fixes.' },
      ]}
      supportLink="/contact"
    />
  );
}
